import { IMockProps } from '_core/types';
import { ENDPOINT_API_PATH } from '../Definitions/CheckUpdateMemberStatusDef';

const autoGenerateSuccess = () => {
  const validateSuccess: IMockProps = {
    doc: {
      code: 'Enviado com Sucesso',
      message: 'Enviado com Sucesso',
    },
    configRequest: {
      method: 'GET',
      path: ENDPOINT_API_PATH,
    },
    configResponse: {
      status: 200,
      data: {
        status: 'IN_PROGRESS',
        message: 'Existe atualização cadastral do membro em aberto.',
      },
    },
  };
  return validateSuccess;
};

const generatedSuccessMocks = [autoGenerateSuccess()];

const CheckUpdateMemberStatus = [...generatedSuccessMocks];
export default CheckUpdateMemberStatus;
